import styled from 'styled-components';
import React, { useContext, useState } from 'react';
import Header from '../components/interstitial/Header';
import {
  Container,
  OuterWrapper,
  CardWrapper,
  Footer,
} from '../components/interstitial/styled';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { EditorContext } from '../../../utils/contexts';
import { FORM_GOALS } from '../constants';
import { FORM_GOAL_ICONS as GOAL_ICONS } from '../forms/constants';
import { buildFormGoalPayload } from '../forms/utils';

const FullCard = styled.div`
  position: relative;
  border: 2px solid #dcdcdc;
  border-radius: 5px;
  padding: 2em 1.14em;
  text-align: center;
  cursor: pointer;
  margin: 0 0.75em;
  background: #fff;
  transition: 0.3s all ease-in-out;
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 15.5em;
  min-height: 15em;
  &:hover, &.active {
    border-color: #e8562a;
  }
  h6 {
    white-space: nowrap;
    line-height: 133%;
    padding-bottom: 0.5em;
    font-size: 1.2em;
    color: #666;
  }
  p {
    color: #888;
    font-size: 0.85em;
    margin-top: 1em;
    line-height: 150%;
  }
`;

const FullIconWrap = styled.div`
  color: #e8562a;
  margin: 8px 0 4px;
`;

export default function FormGoalSelection() {
  const history = useHistory();
  const match = useRouteMatch();
  const { dispatch, settings, siteSettings } = useContext(EditorContext);
  const [active, setActive] = useState(settings.form_type);

  const onSelect = (goal) => {
    setActive(goal.form_type);
    dispatch({ type: 'update', payload: buildFormGoalPayload(goal, siteSettings) });

    const pathParts = window.location.pathname.split('/');
    const siteId = match.params.siteId || pathParts[pathParts.indexOf('sites') + 1];

    try {
      window.analytics?.track('Form Goal Selected', { form_type: goal.form_type, site_id: siteId });
    } catch (_) {}

    history.push(`/sites/${siteId}/forms/new/interstitial/layout`);
  };

  const rows = [FORM_GOALS.slice(0, 3), FORM_GOALS.slice(3)];
  return (
    <div>
      <Header text="CHOOSE FORM GOAL" />
      <Container>
        <h5>What kind of form do you want to create?</h5>
        <p>Choose a goal to get started. You can change this later.</p>
        <OuterWrapper>
          {rows.map((row, ri) => (
            <CardWrapper key={ri}>
              {row.map((goal) => {
                const Icon = GOAL_ICONS[goal.key];
                return (
                  <FullCard
                    key={goal.key}
                    className={active === goal.form_type ? 'active' : ''}
                    onClick={() => onSelect(goal)}
                  >
                    <h6>{goal.label}</h6>
                    {Icon && (
                      <FullIconWrap>
                        <Icon style={{ fontSize: 48 }} />
                      </FullIconWrap>
                    )}
                    <p>{goal.description}</p>
                  </FullCard>
                );
              })}
            </CardWrapper>
          ))}
        </OuterWrapper>
        <Footer />
      </Container>
    </div>
  );
}
